import { PropsWithChildren } from "react";
import { SxProps, Theme } from "@mui/material";
import { IContextMenuProps as IBaseContextMenuProps, ContextMenu as BaseContextMenu } from "src/components-mui/base/context-menu/context-menu";
import { getMenuVariants } from "src/theme-mui/components/menu/styles";
import { toSxArray } from "src/utils/mui/sx/sx";

type TContextMenuStyleVariant = "contextMenu";

export interface IContextMenuProps extends Omit<IBaseContextMenuProps, "sx"> {
    styleVariant?: TContextMenuStyleVariant;
    sx?: SxProps<Theme>;
}

const getMergedSx = (styleVariant: TContextMenuStyleVariant, sx: SxProps<Theme> | undefined): SxProps<Theme> => {
    const baseVariantSx = (theme: Theme) => ({
        "& .MuiMenu-paper": getMenuVariants(theme)[styleVariant].list,
    });

    return [baseVariantSx, ...toSxArray(sx)];
};

export const ContextMenu = ({
    children,
    disableAutoFocusItem = true,
    variant = "menu",
    styleVariant = "contextMenu",
    sx,
    ...menuProps
}: PropsWithChildren<IContextMenuProps>) => {
    return (
        <BaseContextMenu disableAutoFocusItem={disableAutoFocusItem} variant={variant} sx={getMergedSx(styleVariant, sx)} {...menuProps}>
            {children}
        </BaseContextMenu>
    );
};
